<template>
    <v-dialog v-model="dialogVisible" width="700" persistent >
        <v-card>
            <v-card-title
                class="headline grey lighten-2"
                primary-title
            >
                Informe
            </v-card-title>

            <v-card-text>
                <p>
                    A Lei Geral de Proteção de Dados entrou em vigor em setembro e também impõe sanções para envio de SMS sem autorização do usuário. Os princípios de proteção de dados da LGPD já devem ser seguidos conforme a lei eleitoral. Isso significa que a Justiça Eleitoral poderá avaliar ilícitos com base na resolução do TSE.
                </p>
                <p>
                    <b>Ressaltamos a informação, contida neste  informativo, que não é permitido a utilização da nossa rota de SMS para o seguintes fins:</b>
                    campanhas que façam menção ou alusão a campanhas políticas e partidárias, pesquisas eleitorais, informações sobre eventos políticos "comícios, carreatas, etc".
                </p>
                <p>
                    Estamos informando que na existência de casos de  desrespeito ao informativo sobre restrições que está na plataforma e a legislação vigente, reforçamos que todas as campanhas políticas sem devida autorização ou aviso prévio, poderá sofrer sanções financeiras e jurídicas severas.
                    O envio de mensagens em massa, usado de forma inapropriada,  pode gerar multa aos candidatos e à sua equipe de R$ 5 mil a R$ 30 mil ou valor equivalente ao dobro da quantia gasta, caso superado o limite máximo.
                    Qualquer dúvida estamos à disposição.
                </p>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    flat
                    @click="closeInforme"
                >
                    Entendi
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'Informe_LGPD',

    props: ['dialogVisible'],

    methods: {
        closeInforme() {
            this.$store.commit('SET_SHOW_INFORME_LGPD', false)
        }
    }
}
</script>

<style scoped>
p {
    margin-bottom: 5px;
    text-align: justify;
}
</style>



// WEBPACK FOOTER //
// src/components/InformeLGPD.vue